import request from '@/utils/qqMapRequest.js';

// 关键词输入提示
export function mapSuggestion(params) { 
  return request({
      url:'/ws/place/v1/suggestion',
      method:'GET',
      params
  })
}

export function geocoder(params) { 
  return request({
      url:'/ws/geocoder/v1',
      method:'GET',
      params
  })
}

